<div class="Loyalty ui-g-12 ui-md-12 ui-lg-12">

  <div class="ui-g">
    <div class="ui-g-9 ui-md-9 ui-lg-9">
      <h1 class="step-title" >{{ 'movement.import_title' | translate }}</h1>
    </div>
    <div class="ui-g-3 ui-md-3 ui-lg-3 form-button-row">
      <button pButton class="k-generic-btn" type="button" icon="fa fa-arrow-left" iconPos="left" routerLink="/loyalty/movement" label="{{ 'common.back' | translate }}"></button>
    </div>
  </div>

  <div class="card">

    <div class="ui-g ui-fluid">

      <div class="ui-g-12 ui-md-4">
        <button pButton class="k-generic-btn" type="button" icon="fa fa-play"
                iconPos="left" label="{{ 'movement.import' | translate }}" (click)="viewImportDialog = true;"></button>
      </div>

      <div class="ui-g-12 ui-md-8">
        <span class="label"> {{ 'movement.import_result' | translate }} </span>
        <span class="label"> {{ stringaEsito }} </span>
      </div>
    </div>
  </div>

  <p-dialog header="{{ 'movement.import' | translate }}" [(visible)]="viewImportDialog" [modal]="true" [draggable]="false" [resizable]="false" [width]="500">
    <div class="ui-dialog-content">
      <div class="ui-g-12 ui-md-12">
        <p-fileUpload #fileUploadRef data-testid="fileUploadRef" name="movementimport[]" customUpload="true" multiple="false" auto="true" (uploadHandler)="onMovementFileUpload($event)"></p-fileUpload>
      </div>
    </div>

    <div class="ui-dialog-footer">
      <button pButton class="k-generic-btn" type="button" icon="fa fa-play" iconPos="left" label="{{ 'movement.run_import' | translate }}" (click)="runImportMovement(fileUploadRef)"></button>
    </div>
  </p-dialog>

</div>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-movement/form-import-movement-loyalty/form-import-movement-loyalty.component.html